import React, { FC, useCallback, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import DetailPageHeaderBase from '../detail_page_header/DetailPageHeader';
import {
	brandsRestCrudThunksForBuyer,
	brandsRestCrudThunksForSupplier,
} from '../../thunks/brands_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { withUserType } from '../withUserType';
import { getBackLinkStates, generateBackLink } from '../../utils/HistoryUtils';
import { updateNavbarState } from '../../actions/navbar_actions';

const Color = require('color');

const DetailPageHeader = DetailPageHeaderBase as any;

const BrandDetailPage: FC<any> = ({
	match,
	history,
	location,
	userType,
	brand,
	brandFetching,
	childRoutes,
	getBrand,
	updateNavbar,
}): React.ReactElement => {
	const brandId = match.params.id;

	const defaultBackLinkTo = `/${userType}/locations/overview/brands/overview`;
	const defaultBackLinkText = 'Brands';

	useEffect(() => {
		getBrand(brandId);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [brandId]);

	useEffect(() => {
		const { backLinkText, backLinkTo } = getBackLinkStates(location, defaultBackLinkTo) as any;
		updateNavbar(
			backLinkText || defaultBackLinkText,
			backLinkTo || generateBackLink(defaultBackLinkTo, location),
			Color('#6237a0').darken(0.2).toString()
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.search]);

	const tabs = useMemo(() => [{ key: 'details', name: 'Details' }], []);

	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/locations/overview/brands/detail/${brandId}/${key}`),
		[history, userType, brandId]
	);

	const checkTabActive = useCallback(
		(key) => location.pathname.indexOf(key) !== -1,
		[location.pathname]
	);

	return (
		<DetailPageHeader
			exactPath={`/${userType}/locations/overview/brands/detail/${brandId}`}
			redirectPath={`/${userType}/locations/overview/brands/detail/${brandId}/details`}
			backLinkText="Brands"
			backLinkTo={`/${userType}/locations/overview/brands/overview`}
			title={brandFetching ? null : nullSafeGet('brandName', brand)}
			tabs={tabs}
			handleTabChange={handleTabChange}
			checkTabActive={checkTabActive}
			childRoutes={childRoutes}
		/>
	);
};

const mapStateToProps = (state) => ({
	brand: state.brands.detail,
	brandFetching: state.brands.fetching,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getBrand: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? brandsRestCrudThunksForSupplier.readOne(id)
				: brandsRestCrudThunksForBuyer.readOne(id)
		),
	updateNavbar: (backlinkTitle, backlinkTo, backgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, backgroundColor)),
});

export default withUserType(
	withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandDetailPage as any)) as any
);
